"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var FontAwesomeIcon = /** @class */ (function (_super) {
    __extends(FontAwesomeIcon, _super);
    function FontAwesomeIcon() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.typeMap = {
            solid: "fas",
            light: "fal",
            regular: "far",
            brands: "fab",
        };
        return _this;
    }
    FontAwesomeIcon.prototype.render = function () {
        var style = this.props.style;
        var className = this.props.className || "";
        className = "".concat(className, " fa-").concat(this.props.icon);
        className = "".concat(className, " ").concat(this.typeMap[this.props.type || "light"]);
        if (this.props.color) {
            className = "".concat(className, " text-").concat(this.props.color);
        }
        if (this.props.spin) {
            className = "".concat(className, " fa-spin");
        }
        if (this.props.pulse) {
            className = "".concat(className, " fa-pulse");
        }
        if (this.props.pull) {
            className = "".concat(className, " fa-pull-").concat(this.props.pull);
        }
        if (this.props.size) {
            className = "".concat(className, " fa-").concat(this.props.size);
        }
        if (this.props.border) {
            className = "".concat(className, " fa-border");
        }
        if (this.props.inverse) {
            className = "".concat(className, " fa-inverse");
        }
        if (this.props.fixedWidth) {
            className = "".concat(className, " fa-fw");
        }
        if (this.props.rotation) {
            className = "".concat(className, " fa-rotate-").concat(this.props.rotation);
        }
        if (this.props.flip) {
            className = "".concat(className, " fa-flip-").concat(this.props.flip);
        }
        if (this.props.onClick) {
            style = __assign(__assign({}, style), { cursor: "pointer" });
        }
        return React.createElement("i", { onClick: this.props.onClick, className: className, title: this.props.title, style: style });
    };
    return FontAwesomeIcon;
}(React.Component));
exports.default = FontAwesomeIcon;
//# sourceMappingURL=FontAwesomeIcon.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/FontAwesomeIcon.js
// module id = 332
// module chunks = 0